import { useId, useMemo } from 'react'

const SvgBlock = () => (
  <>
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M94.5 143V0H775V569H148.5V426H0V284H201V143H94.5Z"
      fill="white"
    />
  </>
)

const SvgSquare = () => (
  <>
    <rect width="100%" height="100%" fill="currentColor"></rect>
  </>
)

const SvgMontange = () => (
  <>
    <g clipPath="url(#clip0_1526_5717)">
      <path
        d="M817 708L737.368 487.336L624.461 493.799L543.598 262.482L457.676 307.971L319.121 0L199.572 318.543L98.3934 214.352L0 708H817Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5717">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgExtrano = () => (
  <>
    <g clipPath="url(#clip0_1526_5724)">
      <path
        d="M0 532.274H163.255V642.964H326.51V768H490.481V603.195H653.745V480.467H817V232.899H653.745V87.1456H489.774V142.749H327.226V-50H163.255V87.1456H0V532.274Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5724">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgFence = () => (
  <>
    <g clipPath="url(#clip0_1526_5723)">
      <path
        d="M545.283 -98V51.5705H406.604V117.727H271.069V172.673H138.68V-1.93156H0V313.114V656.112H138.68V576.805H271.069V895H409.749V632.125H545.283V750.224H683.963V504.461H817V370.452V84.1882H683.963V-98H545.283Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5723">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgGearReverse = () => (
  <>
    <g clipPath="url(#clip0_1526_5722)">
      <path
        d="M639.797 -5.70188C639.797 -7.14332 639.866 -8.5615 639.913 -9.97969L15.0926 -20C15.0231 -15.6757 15 -11.3514 15 -7.0271C15 180.918 79.9239 363.167 198.615 508.45L264.511 454.14C308.65 508.171 360.335 555.599 418.037 594.867C485.646 640.9 560.546 675.076 639.519 696L654.564 638.691C709.79 653.315 766.728 660.754 824.014 660.754C825.009 660.754 826.005 660.754 827 660.754L824.847 179.314C824.57 179.314 824.292 179.314 824.014 179.314C722.289 179.314 639.82 96.4776 639.82 -5.70188H639.797Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5722">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgFactorySide = () => (
  <>
    <g clipPath="url(#clip0_1526_5734)">
      <path
        d="M291.191 4.83068e-05L291.191 116.517L117.602 116.517L117.602 233.933L196.922 233.933L196.922 350.45L34.0267 350.45L34.0267 466.067L98.7773 466.067L98.7773 582.584L-5.13241e-06 582.584L0 700L819 700L819 2.52355e-05L291.191 4.83068e-05Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5734">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgQgear2 = () => (
  <>
    <g clipPath="url(#clip0_1526_5721)">
      <path
        d="M817.979 520.237C818.334 520.237 818.667 520.26 819 520.26L818.29 2C665.195 2.20006 516.385 53.1258 395.166 146.797C273.947 240.468 187.023 371.706 148 519.948L202.716 534.397C188.754 587.434 181.651 642.117 181.651 697.133C181.651 698.088 181.651 699.044 181.651 700L641.311 699.933C641.311 710.666 641.311 700.399 641.311 700.133C641.311 602.438 720.4 520.237 817.957 520.237H817.979Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5721">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgSpaceship = () => (
  <>
    <g clipPath="url(#clip0_1526_5732)">
      <path
        d="M855 500.219V399.553H771.093V299.667H725.317V199.772H604.592V99.8859H530.472V0H292.527V99.8859H218.408V199.772H97.6834V299.667H51.8977V399.553H-32V500.219H114.478V599.335H31.5802V700H791.42V599.335H708.522V500.219H855Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5732">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgJawbreaker = () => (
  <>
    <g clipPath="url(#clip0_1526_5713)">
      <path
        d="M709.897 204.513C641.614 58.0808 467.58 -5.28207 321.177 62.9868C318.8 64.0955 316.443 65.2303 314.104 66.4021L282.058 -2.32122C102.765 85.8929 26.1594 301.773 111.026 483.771C195.894 665.769 416.141 747.932 600.48 661.973C654.384 636.837 699.341 600.307 733.825 556.594L673.451 510.694C740.463 426.614 758.409 308.587 709.878 204.513L709.897 204.513Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5713">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgQgear = () => (
  <>
    <g clipPath="url(#clip0_1526_5720)">
      <path
        d="M817.067 491.917C817.482 491.917 817.611 491.943 818 491.943L817.067 0C714.894 0.128653 614.25 22.437 521.665 65.3299C429.649 107.94 348.077 169.925 282.544 246.885L249.946 219.507C136.346 352.895 74 522.022 74 696.681C74 697.787 74 698.894 74 700L610.596 700.607C610.596 702.298 610.596 700.309 610.596 700C610.596 586.914 703.182 491.917 817.067 491.917Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5720">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgWave = () => (
  <>
    <g clipPath="url(#clip0_1526_5712)">
      <path
        d="M934.196 359.487L1029.52 290.75C902.468 114.628 695.567 0 461.907 0C418.642 0 376.291 3.94332 335.197 11.4585L356.472 127.101C257.762 145.175 167.748 188.152 93.1982 249.288L169.333 342.356C65.9684 427.124 0 555.839 0 700H1044C1044 572.856 1003.28 455.241 934.196 359.473V359.487Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5712">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgMontana = () => (
  <>
    <g clipPath="url(#clip0_1526_5719)">
      <path
        d="M0 701L147.568 316.416L204.395 473.969L407.088 0L550.37 352.884L681.065 196.685L818 700L0 701Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5719">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)
const SvgApilado = () => (
  <>
    <g clipPath="url(#clip0_1526_5728)">
      <path
        d="M-5 279.474H121.26V139.743H208.08V0H654.927V139.743H799.205V280.772H694.803V419.216H895V560.257H761.245V700H208.08V560.257H86.1646V420.515H-5V279.474Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5728">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgFactory = () => (
  <>
    <g clipPath="url(#clip0_1526_5726)">
      <path
        d="M818 343.212H681.842V138.612H544.633V232.101H408.475V40.1055H273.367V116.424H137.209V0H0V702H818V343.212Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5726">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgButterFly = () => (
  <>
    <path
      d="M398.065 356.458C366.943 164.612 200.624 18.1388 0 18.1388V824.881C206.888 824.881 377.3 669.06 400.54 468.423C431.662 660.269 597.981 806.742 798.605 806.742V0C591.716 0 421.305 155.821 398.065 356.458Z"
      fill="currentColor"
    />
  </>
)

const SvgSlicedTriangle = () => (
  <>
    <path
      d="M852.943 709.285H132.011L0 968.756H985L852.943 709.285Z"
      fill="currentColor"
    />
    <path
      d="M492.479 0.984375L311.104 357.419H673.9L492.479 0.984375Z"
      fill="currentColor"
    />
    <path
      d="M700.515 409.77H284.485L158.674 656.934H826.326L700.515 409.77Z"
      fill="currentColor"
    />
  </>
)

const SvgBullseye = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M759.5 1519C1178.96 1519 1519 1178.96 1519 759.5C1519 340.04 1178.96 0 759.5 0C340.04 0 0 340.04 0 759.5C0 1178.96 340.04 1519 759.5 1519ZM760 1185C995.826 1185 1187 993.826 1187 758C1187 522.174 995.826 331 760 331C524.174 331 333 522.174 333 758C333 993.826 524.174 1185 760 1185Z"
      fill="currentColor"
    />
    <circle cx="760" cy="760" r="326" fill="currentColor" />
  </>
)

const SvgTripleDown = () => (
  <>
    <path d="M1321.07 0H0L660.536 360L1321.07 0Z" fill="currentColor" />
    <path d="M660.536 720L1321.07 360H0L660.536 720Z" fill="currentColor" />
    <path d="M660.536 1080L1321.07 720H0L660.536 1080Z" fill="currentColor" />
  </>
)

const SvgBrokenPie = () => (
  <>
    <path
      d="M642.799 122.845C559.042 96.4362 480.406 97.1037 397.133 125.007L523.25 502.004L642.799 122.845Z"
      fill="currentColor"
    />
    <path
      d="M369.886 174.915C328.228 188.86 294.865 206.229 259.549 232.358C83.0681 362.987 45.8425 611.908 176.444 788.437L495.99 551.956L369.873 174.958L369.886 174.915Z"
      fill="currentColor"
    />
    <path
      d="M663.232 195.833L543.684 574.993L224.137 811.473C276.403 882.064 340.422 927.758 424.135 954.153C633.549 1020.18 856.8 903.918 922.818 694.533C988.837 485.149 872.603 261.847 663.232 195.833Z"
      fill="currentColor"
    />
  </>
)

const SvgBlob = () => (
  <path
    xmlns="http://www.w3.org/2000/svg"
    d="M861 174.232C861 77.9818 782.926 0 686.671 0C590.415 0 512.779 77.5931 512.341 173.503C467.568 153.972 418.128 143.088 366.16 143.088C163.926 143.088 0 306.923 0 509.044C0 711.165 163.926 875 366.16 875C568.393 875 732.319 711.165 732.319 509.044C732.319 451.372 718.901 396.809 695.129 348.27C787.496 343.849 861 267.616 861 174.232Z"
    fill="currentColor"
  />
)

const SvgSprawlingRange = () => (
  <path
    xmlns="http://www.w3.org/2000/svg"
    d="M1061.55 626.901L788.822 400.523L707.963 467.631L532.136 178.604L426.537 352.194L273.355 0.200195L0.623047 626.901H259.404H516.09H546.087H804.867H1061.55Z"
    fill="currentColor"
  />
)

const SvgTripleSlant = () => (
  <>
    <path
      d="M162.657 121.683L0.911621 529.752L199.874 529.929L360.983 121.718L162.657 121.683Z"
      fill="currentColor"
    />
    <path
      d="M646.199 0.348305L447.836 0.312988L267.042 460.423L466.004 460.565L646.199 0.348305Z"
      fill="currentColor"
    />
    <path
      d="M625.139 151.108L444.31 611.183L643.272 611.359L823.466 151.143L625.139 151.108Z"
      fill="currentColor"
    />{' '}
  </>
)

const SvgRoundBars = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M206 0H161.576C72.3438 0 0 72.4062 0 161.648C0 250.887 72.3438 323.234 161.576 323.234H206H252.188H1256.61C1345.84 323.234 1418.19 250.887 1418.19 161.648C1418.19 72.4062 1345.84 0 1256.61 0H252.188H206Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M206.061 379H161.576C72.3438 379 0 451.406 0 540.648C0 629.887 72.3438 702.234 161.576 702.234H206.061H252.188H832.105C921.34 702.234 993.682 629.887 993.682 540.648C993.682 451.406 921.34 379 832.105 379H252.188H206.061Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M206.061 756H161.576C72.3438 756 0 828.406 0 917.648C0 1006.89 72.3438 1079.23 161.576 1079.23H206.061H252.188H1130.1C1219.34 1079.23 1291.68 1006.89 1291.68 917.648C1291.68 828.406 1219.34 756.062 1130.1 756.062V756H252.188H206.061Z"
      fill="currentColor"
    />
  </>
)

const SvgSlant = () => (
  <path
    xmlns="http://www.w3.org/2000/svg"
    d="M0.506104 497.353L291.138 497.623L486.375 0.0480954L196.668 0.0180664L0.506104 497.353Z"
    fill="currentColor"
  />
)
const SvgBars = () => (
  <>
    <path
      d="M174.474 0.839844H0.789307V539.717H174.474V0.839844Z"
      fill="currentColor"
    />
    <path
      d="M380.598 250.953H206.914V828.482H380.598V250.953Z"
      fill="currentColor"
    />
    <path
      d="M586.724 122.522H413.039V561.337H586.724V122.522Z"
      fill="currentColor"
    />
  </>
)

const SvgDoubleTriangles = () => (
  <>
    <path
      d="M0.132812 316.389H296.637L148.37 0.629395L0.132812 316.389Z"
      fill="currentColor"
    />
    <path
      d="M296.638 316.389L444.875 632.148L593.142 316.389H296.638Z"
      fill="currentColor"
    />
  </>
)

const SvgRank = () => (
  <>
    <path
      d="M957.828 921.116L1254.12 624.894L629.157 -2.73179e-05L4.11911 624.894L308.041 928.746L636.712 600.074L957.828 921.116Z"
      fill="currentColor"
    />
    <path
      d="M632.593 1419.73L953.708 1740.8L1250 1444.55L625.038 819.603L-2.73173e-05 1444.55L303.922 1748.35L632.593 1419.73Z"
      fill="currentColor"
    />
  </>
)

const SvgDonutBite = () => (
  <path
    xmlns="http://www.w3.org/2000/svg"
    d="M294.11 586.874V389.181C241.275 389.181 198.419 346.324 198.419 293.49H0.725586C0.725586 455.539 132.09 586.874 294.11 586.874ZM294.11 389.181V586.874C456.159 586.874 587.494 455.509 587.494 293.49H389.8C389.8 346.324 346.974 389.181 294.11 389.181ZM587.524 293.46C587.524 131.411 456.159 0.0759277 294.14 0.0759277V197.769C346.974 197.769 389.83 240.626 389.83 293.46H587.524Z"
    fill="currentColor"
  />
)

const SvgRightTriangle = () => (
  <path d="M0 0V209H209L0 0Z" fill="currentColor" />
)

const SvgStacked = () => (
  <path
    d="M142.318 0V65.8861H0V132.228H131.294V198.114H170.505V264H417.066V198.114H486V131.777H347.355V66.3418H397.072V0H142.318Z"
    fill="currentColor"
  />
)

const Svg50percentCircle = () => (
  <path
    d="M174.5 0C78.1233 0 0 78.3508 0 175H125.812C125.812 148.031 147.608 126.166 174.5 126.166C201.392 126.166 223.188 148.031 223.188 175H349C349 78.3472 270.873 0 174.5 0Z"
    fill="currentColor"
  />
)

const SvgDeathStar = () => (
  <>
    <g clipPath="url(#clip0_1526_5714)">
      <path
        d="M700.97 178.94L628.692 218.008C594.68 158.345 537.68 111.731 465.987 92.5214C463.589 91.8788 461.189 91.2755 458.78 90.7019L480.007 11.4825C296.348 -33.6506 109.61 75.7364 60.5923 258.673C11.5746 441.61 121.422 634.632 307.371 684.457C493.319 734.282 684.321 624.433 733.979 439.107C758.43 347.854 744.052 255.32 700.963 178.938L700.97 178.94Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5714">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgVerticalLines = () => (
  <>
    <g clipPath="url(#clip0_1526_5723)">
      <path
        d="M545.283 -98V51.5705H406.604V117.727H271.069V172.673H138.68V-1.93156H0V313.114V656.112H138.68V576.805H271.069V895H409.749V632.125H545.283V750.224H683.963V504.461H817V370.452V84.1882H683.963V-98H545.283Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5723">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const Svg50percentOval = () => (
  <path
    d="M199.997 220.887C199.968 98.913 155.231 0.0522658 100.045 0H99.9521C44.7631 0.0522658 0.0290255 98.913 0 220.887V221H200V220.887H199.997Z"
    fill="currentColor"
  />
)

const Svg25percentPie = () => (
  <path d="M0 0C0 112.666 91.3339 204 204 204V0H0Z" fill="currentColor" />
)

const SvgOval = () => (
  <path
    d="M67.0778 0C30.0302 0 0 29.9954 0 67C0 104.005 30.0302 134 67.0778 134H228.922C265.97 134 296 103.998 296 67C296 30.0015 265.97 0 228.922 0H67.0778Z"
    fill="currentColor"
  />
)

const Svg3rdPie = () => (
  <path
    d="M329.876 207.957C326.001 93.814 232.669 2.60814 119.381 0L118.151 169.367C129.175 169.63 140.185 174.052 148.613 182.706C163.664 198.17 165.117 222.904 151.896 239.615C137.637 257.631 112.455 260.761 94.1032 248.665L0 388.586C35.5486 412.393 78.4347 425.922 124.21 424.951C241.775 422.466 333.855 325.315 329.876 207.962"
    fill="currentColor"
  />
)

const SvgRounds = () => (
  <path
    d="M279.723 272.949H208.445C208.445 334.381 224.402 384.176 244.082 384.176C263.761 384.176 279.723 334.377 279.723 272.949ZM185.757 272.949H94.5144C94.5144 377.356 114.939 462 140.136 462C165.332 462 185.757 377.36 185.757 272.949ZM0 272.949H117.207C117.207 122.203 90.9704 0 58.6056 0C26.2409 0 0.00446785 122.203 0.00446785 272.949M150.121 272.949H221.398C221.398 211.516 205.441 161.721 185.757 161.721C166.073 161.721 150.116 211.521 150.116 272.949M351 272.949C351 142.901 328.625 37.474 301.022 37.474C273.42 37.474 251.045 142.901 251.045 272.949H351Z"
    fill="currentColor"
  />
)

const SvgTheS = () => (
  <path
    d="M196.821 173.23V0C88.1197 0 0 88.1459 0 196.879C0 298.358 76.7637 381.876 175.369 392.573V465C256.351 465 322 399.332 322 318.325C322 244.61 267.629 183.611 196.821 173.23Z"
    fill="currentColor"
  />
)

const SvgMountains = () => (
  <>
    <g clipPath="url(#clip0_1526_5718)">
      <path
        d="M817 702L714.873 253.805L612.754 412.37L510.909 0L408.5 253.942L306.373 113.79L204.254 246.106L110.127 501.732L0 702H817Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5718">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgStackedPie = () => (
  <>
    <g clipPath="url(#clip0_1526_5710)">
      <path
        d="M122.268 331.388V559.571H0V700H815.997C817.307 684.02 818 667.848 818 651.483C818 323.726 552.077 58 224.075 58C223.266 58 222.495 58 221.686 58V331.35H122.268V331.388Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5710">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgHillOne = () => (
  <>
    <g clipPath="url(#clip0_1526_5711)">
      <path
        d="M706.866 184.968V0C316.45 0 0 313.426 0 700H706.866H1227C1227 415.553 994.153 184.918 706.866 184.918V184.968Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5711">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgExtrudedCircle = () => (
  <path
    d="M388.038 0C385.353 0 382.676 0.0334118 379.999 0.0918816V52.9653C204.755 57.2252 64 200.418 64 376.437C64 552.456 209.072 700 388.029 700C566.987 700 712.042 555.154 712.059 376.47H765C765 376.47 765 376.445 765 376.437C765 168.543 596.222 0.00835461 388.029 0.00835461L388.038 0Z"
    fill="currentColor"
  />
)

const SvgJaggedMountain = () => (
  <>
    <g clipPath="url(#clip0_1526_5716)">
      <path
        d="M817 700L714.879 143.473L612.75 364.001L510.908 0L408.5 224.155L306.379 100.446L204.25 490.394L102.129 291.384L0 700H817Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5716">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgJaggedCircle = () => (
  <path
    xmlns="http://www.w3.org/2000/svg"
    d="M667.667 256.899L735.719 207.952C645.018 82.5373 497.315 0.911621 330.509 0.911621C299.623 0.911621 269.389 3.71962 240.053 9.07112L255.241 91.4191C184.774 104.289 120.514 134.892 67.2943 178.427L121.646 244.7C47.8554 305.062 0.761719 396.719 0.761719 499.374H746.055C746.055 408.836 716.983 325.084 667.667 256.888V256.899Z"
    fill="currentColor"
  />
)

const SvgRockyHillside = () => (
  <>
    <g clipPath="url(#clip0_1526_5734)">
      <path
        d="M291.191 4.83068e-05L291.191 116.517L117.602 116.517L117.602 233.933L196.922 233.933L196.922 350.45L34.0267 350.45L34.0267 466.067L98.7773 466.067L98.7773 582.584L-5.13241e-06 582.584L0 700L819 700L819 2.52355e-05L291.191 4.83068e-05Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5734">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

const SvgBookshelf = () => (
  <>
    <g clipPath="url(#clip0_1526_5730)">
      <path
        d="M40.1473 0V175.902H172.179V349.399H-84V525.3H99.0559V700H641.82V525.3H745.947V350.601H905V174.711H716.681V0H40.1473Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_5730">
        <rect width="817" height="700" fill="white" />
      </clipPath>
    </defs>
  </>
)

export const BackgroundShapes: Array<ShapeType> = [
  'theS',
  'hill-1',
  'donutBite',
  'rank',
  'doubleTriangle',
  'bars',
  'slant',
  'roundBars',
  'tripleSlant',
  'sprawlingRange',
  'blob',
  'brokenPie',
  'tripleDown',
  'bullseye',
  'slicedTriangle',
  'butterfly',
]

export const DALTON_SHAPES: Array<ShapeType> = [
  'stackedPie',
  'apilado',
  'deathStar',
  'extrudedCircle',
  'block',
]

export const ImageShapes: Array<ShapeType> = [
  'stackedPie',
  'apilado',
  'deathStar',
  'extrudedCircle',
  'block',
  'verticalLines',
  'jaggedMountain',
  'rockyHillside',
  'bookshelf',
  'mountains',
  'hill-1',
  'factory',
  'montana',
  'wave',
  'qGear',
  'jawbreaker',
  'spaceship',
  'qGear2',
  'factorySide',
  'gearReverse',
  'fence',
  'extrano',
  'montange',
  'square',
]

export type ShapeType =
  | 'butterfly'
  | 'slicedTriangle'
  | 'bullseye'
  | 'tripleDown'
  | 'brokenPie'
  | 'blob'
  | 'sprawlingRange'
  | 'tripleSlant'
  | 'roundBars'
  | 'slant'
  | 'bars'
  | 'doubleTriangle'
  | 'rank'
  | 'donutBite'
  | 'triangle'
  | 'stacked'
  | '50percentCircle'
  | 'deathStar'
  | 'verticalLines'
  | '50percentOval'
  | '25percentPie'
  | 'oval'
  | '3rdPie'
  | 'rounds'
  | 'theS'
  | 'mountains'
  | 'stackedPie'
  | 'hill-1'
  | 'extrudedCircle'
  | 'jaggedMountain'
  | 'jaggedCircle'
  | 'rockyHillside'
  | 'bookshelf'
  | 'factory'
  | 'apilado'
  | 'montana'
  | 'wave'
  | 'qGear'
  | 'jawbreaker'
  | 'spaceship'
  | 'qGear2'
  | 'factorySide'
  | 'gearReverse'
  | 'fence'
  | 'extrano'
  | 'montange'
  | 'block'
  | 'square'

export const BackgroundShape = ({
  name,
  align,
  style,
}: {
  name: ShapeType
  align: 'center' | 'left' | 'right'
  style?: any
}) => {
  const styles = useMemo(() => {
    switch (name) {
      case 'donutBite':
        return {
          transform: align === 'left' ? 'translateX(-8%)' : '',
          scale: '1.5',
        }
      case 'rank':
        return {
          transform: `translateY(5%) ${
            align !== 'center'
              ? `translateX(${align === 'left' ? '20%' : '-20%'})`
              : ''
          }`,
          scale: '1.5',
        }
      case 'doubleTriangle':
        return {
          scale: '1.5',
        }
      case 'bars':
        return {
          scale: '1.5',
          transform: `${
            align !== 'center'
              ? `translateX(${align === 'left' ? '17%' : '-17%'})`
              : ''
          }`,
        }
      case 'theS':
        return {
          scale: '1.5',
          transform: `translateY(-10%) ${
            align !== 'center'
              ? `translateX(${align === 'left' ? '20%' : '-20%'})`
              : ''
          }`,
        }
      case 'roundBars':
        return {
          transform: `${
            align !== 'center'
              ? `${
                  align === 'left'
                    ? 'translateX(-10%)'
                    : 'rotate(180deg) translateX(-10%)'
                }`
              : ''
          }`,
        }
      case 'tripleSlant':
        return {
          transform: `${
            align !== 'center'
              ? `${align === 'left' ? 'translateX(-5%)' : 'translateX(5%)'}`
              : ''
          }`,
        }
      case 'sprawlingRange':
        return {
          transform: `${
            align !== 'center'
              ? `${
                  align === 'left'
                    ? 'translateX(-15%) translateY(10%)'
                    : 'translateX(15%) translateY(10%)'
                }`
              : 'translateY(15%)'
          }`,
        }
      case 'blob':
        return {
          transform: 'translateY(15%)',
          paddingLeft: '5%',
          paddingRight: '5%',
        }
      case 'tripleDown':
        return {
          transform: `${
            align !== 'center'
              ? `${align === 'left' ? 'translateX(-15%)' : 'translateX(15%)'}`
              : ''
          }`,
        }
      case 'bullseye':
        return {
          transform: `${
            align !== 'center'
              ? `${align === 'left' ? 'translateX(-50%)' : 'translateX(50%)'}`
              : ''
          }`,
        }
      case 'butterfly':
        return {
          scale: '0.8',
        }
      case 'hill-1':
        return {
          scale: '0.8',
          transform: `translateY(12%) ${
            align !== 'center'
              ? `${align === 'left' ? 'translateX(-25%)' : 'translateX(25%)'}`
              : ''
          }`,
        }
      default:
        return {}
    }
  }, [name, align])

  return (
    <div
      style={{
        position: 'absolute',
        top: '0',
        left: align !== 'right' ? '0' : '',
        right: align !== 'left' ? '0' : '',
        bottom: '0',
        ...styles,
        ...style,
      }}
      aria-hidden
    >
      <ImageShape name={name} ariaLabel={''} />
    </div>
  )
}

export const ImageShape = ({
  imgUrl,
  name,
  imageOffset,
  showBackground,
  ariaLabel,
  width,
}: {
  imgUrl?: string
  name: ShapeType
  showBackground?: boolean
  imageOffset?: {
    scale?: number
    x: number
    y: number
  }
  ariaLabel: string
  width?: string
}) => {
  const id = useId()
  const ViewBox = useMemo(() => {
    switch (name) {
      case 'butterfly':
        return '0 0 799 825'
      case 'slicedTriangle':
        return '0 0 985 969'
      case 'bullseye':
        return '0 0 1519 1519'
      case 'tripleDown':
        return '0 0 1322 1080'
      case 'brokenPie':
        return '0 0 1062 1074'
      case 'blob':
        return '0 0 861 875'
      case 'sprawlingRange':
        return '0 0 1062 627'
      case 'tripleSlant':
        return '0 0 824 612'
      case 'roundBars':
        return '0 0 1419 1080'
      case 'slant':
        return '0 0 487 498'
      case 'bars':
        return '0 0 587 829'
      case 'doubleTriangle':
        return '0 0 594 633'
      case 'donutBite':
        return '0 0 588 587'
      case 'rank':
        return '0 0 1255 1749'
      case 'triangle':
        return '0 0 209 209'
      case 'stacked':
        return '0 0 486 264'
      case '50percentCircle':
        return '0 0 349 175'
      case '50percentOval':
        return '0 0 200 221'
      case '25percentPie':
        return '0 0 204 204'
      case 'oval':
        return '0 0 296 134'
      case '3rdPie':
        return '0 0 330 425'
      case 'rounds':
        return '0 0 351 462'
      case 'theS':
        return '0 0 322 465'
      case 'jaggedCircle':
        return '0 0 747 500'
      case 'block':
        return '0 0 775 569'
      case 'verticalLines':
      case 'mountains':
      case 'deathStar':
      case 'stackedPie':
      case 'hill-1':
      case 'extrudedCircle':
      case 'jaggedMountain':
      case 'rockyHillside':
      case 'bookshelf':
      case 'factory':
      case 'apilado':
      case 'montana':
      case 'wave':
      case 'qGear':
      case 'jawbreaker':
      case 'spaceship':
      case 'qGear2':
      case 'factorySide':
      case 'gearReverse':
      case 'extrano':
      case 'montange':
      case 'fence':
        return '0 0 817 700'
      case 'square':
        return '0 0 100 100'
      default:
        return ''
    }
  }, [name])

  return (
    <svg
      role="img"
      aria-label={ariaLabel}
      viewBox={ViewBox}
      xmlns="http://www.w3.org/2000/svg"
      style={{ height: '100%', width: width || (!imgUrl ? '100%' : '') }}
    >
      {!imgUrl ? (
        <_Shape name={name} />
      ) : (
        <>
          <mask id={id}>
            <_Shape name={name} />
          </mask>

          <g width="100%" height="100%" mask={`url(#${id})`}>
            {showBackground && (
              <rect x="0" y="0" width="100%" height="100%" fill="red"></rect>
            )}
            <image
              preserveAspectRatio="xMinYMin slice"
              href={imgUrl}
              x={imageOffset?.x || ''}
              y={imageOffset?.y || ''}
              width={`${100 * (imageOffset?.scale || 1)}%`}
            />
          </g>
        </>
      )}
    </svg>
  )
}

const _Shape = (props: { name: ShapeType }) => {
  switch (props.name) {
    case 'butterfly':
      return <SvgButterFly />
    case 'triangle':
      return <SvgRightTriangle />
    case 'stacked':
      return <SvgStacked />
    case '50percentCircle':
      return <Svg50percentCircle />
    case 'deathStar':
      return <SvgDeathStar />
    case 'verticalLines':
      return <SvgVerticalLines />
    case '50percentOval':
      return <Svg50percentOval />
    case '25percentPie':
      return <Svg25percentPie />
    case 'oval':
      return <SvgOval />
    case '3rdPie':
      return <Svg3rdPie />
    case 'rounds':
      return <SvgRounds />
    case 'theS':
      return <SvgTheS />
    case 'mountains':
      return <SvgMountains />
    case 'stackedPie':
      return <SvgStackedPie />
    case 'hill-1':
      return <SvgHillOne />
    case 'extrudedCircle':
      return <SvgExtrudedCircle />
    case 'jaggedMountain':
      return <SvgJaggedMountain />
    case 'jaggedCircle':
      return <SvgJaggedCircle />
    case 'rockyHillside':
      return <SvgRockyHillside />
    case 'bookshelf':
      return <SvgBookshelf />
    case 'donutBite':
      return <SvgDonutBite />
    case 'rank':
      return <SvgRank />
    case 'doubleTriangle':
      return <SvgDoubleTriangles />
    case 'bars':
      return <SvgBars />
    case 'slant':
      return <SvgSlant />
    case 'roundBars':
      return <SvgRoundBars />
    case 'tripleSlant':
      return <SvgTripleSlant />
    case 'sprawlingRange':
      return <SvgSprawlingRange />
    case 'blob':
      return <SvgBlob />
    case 'brokenPie':
      return <SvgBrokenPie />
    case 'tripleDown':
      return <SvgTripleDown />
    case 'bullseye':
      return <SvgBullseye />
    case 'slicedTriangle':
      return <SvgSlicedTriangle />
    case 'factory':
      return <SvgFactory />
    case 'apilado':
      return <SvgApilado />
    case 'montana':
      return <SvgMontana />
    case 'wave':
      return <SvgWave />
    case 'qGear':
      return <SvgQgear />
    case 'jawbreaker':
      return <SvgJawbreaker />
    case 'spaceship':
      return <SvgSpaceship />
    case 'qGear2':
      return <SvgQgear2 />
    case 'factorySide':
      return <SvgFactorySide />
    case 'gearReverse':
      return <SvgGearReverse />
    case 'fence':
      return <SvgFence />
    case 'extrano':
      return <SvgExtrano />
    case 'montange':
      return <SvgMontange />
    case 'block':
      return <SvgBlock />
    case 'square':
      return <SvgSquare />
    default:
      console.warn('unknown svg shape')
      return null
  }
}
